import { render, staticRenderFns } from "./DevicePicture.vue?vue&type=template&id=2d67a9b9&scoped=true&"
import script from "./DevicePicture.vue?vue&type=script&lang=js&"
export * from "./DevicePicture.vue?vue&type=script&lang=js&"
import style0 from "./DevicePicture.vue?vue&type=style&index=0&id=2d67a9b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d67a9b9",
  null
  
)

export default component.exports